import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcHomeFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.75 19.643V11.88a3 3 0 0 0-.989-2.226l-6.42-6.136a2 2 0 0 0-2.682 0L4.24 9.655a3 3 0 0 0-.989 2.226v7.761a1.5 1.5 0 0 0 1.5 1.5H8a1.5 1.5 0 0 0 1.5-1.5v-3a2.5 2.5 0 0 1 5 0v3a1.5 1.5 0 0 0 1.5 1.5h3.25a1.5 1.5 0 0 0 1.5-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m4.239 9.655 6.42-6.136a2 2 0 0 1 2.682 0l6.42 6.136a3 3 0 0 1 .989 2.226v7.761a1.5 1.5 0 0 1-1.5 1.5H16a1.5 1.5 0 0 1-1.5-1.5v-3a2.5 2.5 0 0 0-5 0v3a1.5 1.5 0 0 1-1.5 1.5H4.75a1.5 1.5 0 0 1-1.5-1.5v-7.761a3 3 0 0 1 .989-2.226",
    clipRule: "evenodd"
  }));
}
var IcHomeFill = createNolIcon(/*#__PURE__*/forwardRef(SvgIcHomeFill));

export { IcHomeFill as I };
